<template>
    <td-dialog
        class="auditInfoImport"
        :title="$t('common.IMPORT')"
        :before-close="dialogClose"
        :visible.sync="dialogVisible"
        @cancel="dialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px"
    >
        <td-upload
            :action="actionUrl"
            :autoUpload="false"
            ref="auditFileImport"
            message="workFlowProcessAudit.IMPORT_TIP"
            :multiple="false"
            :limit="1"
            :showFileList="true"
            accept=".xlsx"
            limitSize="50"
            :beforeUpload="beforeUpload"
            :on-success="importSuccess"
            :on-error="importFailed"
            :http-request="importAuditInfo"
        ></td-upload>
    </td-dialog>
</template>

<script>
import Api from '../../assets/api';
export default {
    name: 'auditFileImportDialog',
    props: ['dialogVisible', 'data'],
    data() {
        return {
            //导入请求路径
            actionUrl: ''
        };
    },
    created() {},
    methods: {
        //对导入文件进行上传前的校验
        beforeUpload(file) {
            let fileName = file.name;
            let flag = fileName.substring(fileName.lastIndexOf('.') + 1) != 'xlsx';
            if (flag) {
                this.$message({ type: 'success', showClose: true, message: this.$t('workFlowProcessAudit.IMPORT_RULE') });
                return false;
            }
        },
        //导入成功触发事件
        importSuccess() {
            console.log('success');
        },
        //导入失败触发事件
        importFailed() {
            console.log('failed');
        },
        //弹窗关闭
        dialogClose() {
            this.$emit('dialogClose');
        },
        //上传文件
        importAuditInfo(content) {
            console.dir(content);
            let file = new FormData();
            file.append('file', content.file);
            file.append('sAuditGroupId', this.data.sAuditGroupId);
            Api.importAudit(file, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/auditManage/importAudit', response);
                    return;
                }
                if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                    this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.DELETE_FAIL') });
                    this.$log.error('', response);
                    return;
                }
                this.$emit('refreshAuditInfo'); //导入成功刷新表信息
                this.$message({ type: 'success', showClose: true, message: response.data.content });
            });
        }
    }
};
</script>

<style scoped>
.auditInfoImport .el-dialog__body > div {
    margin: 20px;
    text-align: center;
}
</style>
